import { HttpStatus } from 'utils/constants/http-status';

import { Action } from './action';


export const loginUrl = '/v1/authentication';
export const refreshTokenUrl = 'api/user/v1/refreshToken';


export interface ApiError extends Error {
    status: HttpStatus;
    authentication: boolean;
    handled: boolean;
    actions: Action[];
}

export interface RequestConfig {
    params?: object;
    headers?: object;
    raw?: boolean
    noErrorHandling?: boolean;
}

export interface Response<T = any> {
    data: T;
    status: number;
    headers: any;
}
